import type * as React from 'react';
import { put } from '@Domain/Api';
import type { BeneficiaryTypeGrantsPayload } from '@Application/SubjectTypeDefinitions/Actions/beneficiaryTypeGrantsFetched';
import beneficiaryTypeGrantsSaved, {
	type BeneficiaryTypeGrantsSavedAction,
} from '@Application/SubjectTypeDefinitions/Actions/beneficiaryTypeGrantsSaved';
import beneficiaryTypeGrantsSaveFailed, {
	type BeneficiaryTypeGrantsSaveFailedAction,
} from '@Application/SubjectTypeDefinitions/Actions/beneficiaryTypeGrantsSaveFailed';
import type SaveBeneficiaryTypeGrants from '@Application/SubjectTypeDefinitions/Commands/SaveBeneficiaryTypeGrants';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = BeneficiaryTypeGrantsSavedAction | BeneficiaryTypeGrantsSaveFailedAction;

export default (command: SaveBeneficiaryTypeGrants) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await put<BeneficiaryTypeGrantsPayload>(
				`${parameters.api.host}/api/accounts/${command.accountId}/beneficiary-type-grants`,
				command.toJSON(),
			);

			const action = beneficiaryTypeGrantsSaved(payload, command.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = beneficiaryTypeGrantsSaveFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
